import { Divider, Grid, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
  List,
  Datagrid,
  EditButton,
  TextField,
  FilterButton,
  ExportButton,
  TopToolbar,
  Button,
} from 'react-admin';
import MainLayout from '../layout/MainLayout';
import CustomDeleteButton from './CustomDeleteButton';
import TariffButton from './TariffButton';
import { merchantFilters } from './MerchantFilter';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Color from '../layout/color/Color';

const MerchantActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <ExportButton />
      <TariffButton />
    </TopToolbar>
  );
};

function getWindowDimensions() {
  const { innerWidth: width } = window;
  return {
    width
  };
}

export const MerchantList = () => {
  const [currentScreen, setCurrentScreen] = useState(getWindowDimensions());
  const [currentScreenPx, setCurrentScreenPx] = useState('');

  useEffect(() => {
    function handleResize() {
      setCurrentScreen(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setCurrentScreenPx((currentScreen.width - 70) + 'px')
  }, [currentScreen])


  return (
      <MainLayout>
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            mb: 2,
          }}
        >
          <Button
            endIcon={<AccountBalanceIcon sx={{ color: Color.Main }} />}
            sx={{ cursor: 'default' }}
            size="medium"
          >
            <Typography variant="h3">Merchant Management</Typography>
          </Button>
          <CustomDeleteButton />
        </Grid>
        <Divider sx={{ width: '100%', mb: 2 }} />
        <List filters={merchantFilters} actions={<MerchantActions />}>
          <Datagrid
            bulkActionButtons={false}
            sx={{
              '& .RaDatagrid-tableWrapper': {
                xs: {
                  overflowX: 'scroll',
                  width: currentScreenPx,
                  overflowY: 'hidden',
                  mx: '20px',
                  whiteSpace: 'nowrap'
                },
                md: {
                  overflowX: 'scroll',
                  width: currentScreenPx,
                  overflowY: 'hidden',
                  mx: '20px',
                  whiteSpace: 'nowrap'
                },
                lg: {
                  overflowX: 'scroll',
                  width: '100%',
                  overflowY: 'hidden',
                  whiteSpace: 'nowrap'
                },
                xl: {
                  overflowX: 'scroll',
                  width: '100%',
                  overflowY: 'hidden',
                  whiteSpace: 'nowrap'
                }
              }
            }}>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="brand" />
            <TextField source="type" />
            <TextField source="updated_at" />
            <EditButton />
          </Datagrid>
        </List>
      </MainLayout>
  );
};
